import React from "react";
import { connect } from "react-redux";
import TextBox from 'devextreme-react/text-box';
import DateBox from "devextreme-react/date-box";
import NumberBox from "devextreme-react/number-box";
import CheckBox from "devextreme-react/check-box";
import { SelectBox } from 'devextreme-react/select-box';
import TextArea from 'devextreme-react/text-area';
import InspectionDetailsApi from "../../transactions/inspection/InspectionDetailsApi";
import Button from "devextreme-react/button";
import notify from "devextreme/ui/notify";
import { LoadPanel } from 'devextreme-react/load-panel';

class InspectionAttribute extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            questionsArr: [],
            loadIndicatorVisible: false
        };
        this.InspectionDetailsApi = new InspectionDetailsApi(props.oidc.user.access_token);
        this.LoadInspectionQuestion = this.LoadInspectionQuestion.bind(this);
        this.GetStateValue = this.GetStateValue.bind(this);
        this.SetStateValue = this.SetStateValue.bind(this);
        this.SaveQuestionForm = this.SaveQuestionForm.bind(this);
        this.Reset = this.Reset.bind(this);
    }
    GetStateValue(keyVal, obj) {
        let tmp = this.state.questionsArr.filter(element => element.rowid == keyVal);
        if (tmp.length > 0) {
            if (tmp[0].datatype == 'B')
                return tmp[0].val ? true : false;
            else
                return tmp[0].val;
        }
        return "";
    }
    SetStateValue(keyVal, obj, newval) {
        const newState = this.state.questionsArr.map(obj1 => {
            if (obj1.rowid == keyVal) {
                return { ...obj1, val: newval };
            }
            return obj1;
        });
        this.setState({ questionsArr: newState });
    }
    SaveQuestionForm = async (e) => {
        this.setState({ loadIndicatorVisible: true });
        try {
            const response = await this.InspectionDetailsApi.saveInspectionDetailV2(
                {
                    Inspectiondetailrowids: this.props.inspectionDetailRowids,
                    _lstInspectionAttributeDTO: this.state.questionsArr
                });
            if (response.data.success) {
                notify({
                    message: "Sucessfully Saved!",
                    width: 100,
                }, 'success', 2000);
                this.props.parentCallback();
                this.setState({ loadIndicatorVisible: false });
            }
            else {
                notify({
                    message: response.data.message,
                    width: 100,
                }, 'error', 2000);
                this.setState({ loadIndicatorVisible: false });
            }
        } catch (e) {
            console.log(e, "Error in loading.");
            this.setState({ loadIndicatorVisible: false });
        }
    }
    componentDidMount() {
        this.LoadInspectionQuestion(this.props.inspectiontype);
    }
    LoadInspectionQuestion = async (inspectionTypeRowid) => {
        this.setState({ loadIndicatorVisible: true });
        try {
            const response = await this.InspectionDetailsApi.loadInspectionQuestions(inspectionTypeRowid);
            if (response.data.success) {
                this.setState({
                    questionsArr: response.data.resultdata
                });
                if (this.props?.inspectionDetailRowids?.length == 1) {
                    const inpectionDataResponse = await this.InspectionDetailsApi.loadInspectionAnswers(this.props?.inspectionDetailRowids[0]);
                    if (inpectionDataResponse.data.success && inpectionDataResponse.data.resultdata.length > 0) {
                        var orgArr = this.state.questionsArr;
                        orgArr.forEach(element => {
                            var fltrObj = inpectionDataResponse.data.resultdata.filter((ele) => ele.fieldname == element.name)[0];
                            if (fltrObj) {
                                element.val = (fltrObj.fieldtype == "L" || fltrObj.fieldtype == "S") ? fltrObj.stringvalue :
                                    (fltrObj.fieldtype == "I") ? fltrObj.integervalue :
                                        (fltrObj.fieldtype == "N") ? fltrObj.numbervalue :
                                            (fltrObj.fieldtype == "D") ? fltrObj.datetimevalue :
                                                (fltrObj.fieldtype == "B") ? fltrObj.booleanvalue :
                                                    (fltrObj.fieldtype == "T") ? fltrObj.commentvalue : "";
                                element.abinspdatarowid = fltrObj.rowid;
                            }
                        });
                        this.setState({ questionsArr: orgArr });
                    }
                }
                this.setState({ loadIndicatorVisible: false });
            }
            else {
                notify({
                    message: response.data.message,
                    width: 100,
                }, 'error', 2000);
                this.setState({ loadIndicatorVisible: false });
            }
        } catch (e) {
            this.setState({ loadIndicatorVisible: false });
            console.log(e, "Error in loading.");
        }
    }
    Reset() {
        const newState = this.state.questionsArr.map(obj1 => {
            return { ...obj1, val: null };
        });
        this.setState({ questionsArr: newState });
    }
    render() {
        return (
            <div>
                <div className="row">
                    <LoadPanel
                        shadingColor="rgba(0,0,0,0.4)"
                        visible={this.state.loadIndicatorVisible}
                        showIndicator={true}
                        shading={true}
                        showPane={true}
                        hideOnOutsideClick={false}
                    />
                    <form onSubmit={(e) => this.SaveQuestionForm(e)}>
                        {
                            this.state.questionsArr.map(item => {
                                let keyVal = item.rowid.toLowerCase();
                                switch (item.datatype) {
                                    case 'T': {
                                        return <div className="row" key={keyVal}>
                                            <div className="col-md-12">
                                                <label htmlFor={keyVal} className="field-label">
                                                    {item.name}
                                                </label>
                                                <TextArea
                                                    value={this.GetStateValue(keyVal, item)}
                                                    name={keyVal}
                                                    height={100}
                                                    autoResizeEnabled={false}
                                                    onValueChanged={(data) => this.SetStateValue(keyVal, item, data.value)} />
                                            </div>
                                        </div>
                                        break;
                                    }
                                    case 'S': {
                                        return <div className="row" key={keyVal}>
                                            <div className="col-md-12">
                                                <label htmlFor={keyVal} className="field-label">
                                                    {item.name}
                                                </label>
                                                <TextBox
                                                    type="text"
                                                    name={keyVal}
                                                    value={this.GetStateValue(keyVal, item)}
                                                    onValueChanged={(data) => this.SetStateValue(keyVal, item, data.value)}>
                                                </TextBox>
                                            </div>
                                        </div>
                                        break;
                                    }
                                    case 'D': {
                                        return <div className="row" key={keyVal}>
                                            <div className="col-md-12">
                                                <label htmlFor={keyVal} className="field-label">
                                                    {item.name}
                                                </label>
                                                <DateBox
                                                    type="date"
                                                    name={keyVal}
                                                    displayFormat="shortdate"
                                                    key={keyVal}
                                                    value={this.GetStateValue(keyVal, item)}
                                                    onValueChanged={(data) => this.SetStateValue(keyVal, item, data.value)}
                                                />
                                            </div>
                                        </div>
                                        break;
                                    }
                                    case 'I': {
                                        return <div className="row" key={keyVal}>
                                            <div className="col-md-12">
                                                <label htmlFor={keyVal} className="field-label">
                                                    {item.name}
                                                </label>
                                                <NumberBox
                                                    name={keyVal}
                                                    key={keyVal}
                                                    format="#"
                                                    value={this.GetStateValue(keyVal, item)}
                                                    onValueChanged={(data) => this.SetStateValue(keyVal, item, data.value)} />
                                            </div>
                                        </div>
                                        break;
                                    }
                                    case 'N': {
                                        return <div className="row" key={keyVal}>
                                            <div className="col-md-12">
                                                <label htmlFor={keyVal} className="field-label">
                                                    {item.name}
                                                </label>
                                                <NumberBox
                                                    name={keyVal}
                                                    key={keyVal}
                                                    format="#,##0.00"
                                                    value={this.GetStateValue(keyVal, item)}
                                                    onValueChanged={(data) => this.SetStateValue(keyVal, item, data.value)} />
                                            </div>
                                        </div>
                                        break;
                                    }
                                    case 'B': {
                                        return <div className="row" key={keyVal}>
                                            <div className="col-md-12 mt-4">
                                                <CheckBox
                                                    name={keyVal}
                                                    text={item.name}
                                                    key={keyVal}
                                                    value={this.GetStateValue(keyVal, item)}
                                                    onValueChanged={(data) => this.SetStateValue(keyVal, item, data.value)} />
                                            </div>
                                        </div>
                                        break;
                                    }
                                    case 'L': {
                                        return <div className="row" key={keyVal}>
                                            <div className="col-md-12">
                                                <label htmlFor="" className="field-label">
                                                    {item.name}
                                                </label>
                                                <SelectBox
                                                    dataSource={item.lstlkupdto}
                                                    searchEnabled={true}
                                                    displayExpr="name"
                                                    valueExpr="id"
                                                    name={keyVal}
                                                    className="w-100"
                                                    value={this.GetStateValue(keyVal, item)}
                                                    onValueChanged={(data) => this.SetStateValue(keyVal, item, data.value)} />
                                            </div>
                                        </div>
                                        break;
                                    }
                                }
                            })
                        }
                        <div className="row">
                            <div className="col-md-12 pl-4 mt-5 mb-5">
                                <Button
                                    text="Save Record"
                                    type="default"
                                    useSubmitBehavior={false}
                                    onClick={(e) => this.SaveQuestionForm(e)}
                                    className="mr-2"
                                    stylingMode="contained">
                                </Button>
                                <Button
                                    onClick={this.Reset}
                                    text="Reset"
                                    type="default"
                                    useSubmitBehavior={false}
                                    stylingMode="contained">
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(InspectionAttribute);